import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { hasScopesPermission } from '@tribeplatform/gql-client/lib';
import { useCreateEmojis, useCreateImages, useUpdateSpace, } from '@tribeplatform/react-sdk/hooks';
import { SystemSpacesIcons } from '../common';
import { EntityImage } from '../common/components/EntityImage';
import { useCropImageModal } from '../CropImageModal';
import { PopoverImagePicker } from '../Picker/PopoverImagePicker';
const SpaceImageReadOnly = ({ space, size = 'md', }) => {
    const defaultIcon = SystemSpacesIcons[space.slug];
    return _jsx(EntityImage, { entity: space, size: size, defaultIcon: defaultIcon }, void 0);
};
export const SpaceImage = ({ space, size = 'md', readOnly = true, }) => {
    if (!space) {
        space = {};
    }
    const { mutateAsync: createEmojis } = useCreateEmojis();
    const { mutateAsync: createImages } = useCreateImages();
    const { mutate: updateSpace } = useUpdateSpace();
    const [canUpdateSpace] = hasScopesPermission(space, ['updateSpace']);
    const uploadFile = useCallback(async (files) => {
        var _a;
        const args = [{ file: files[0] }];
        const uploadedImage = await createImages(args);
        if ((_a = uploadedImage === null || uploadedImage === void 0 ? void 0 : uploadedImage[0]) === null || _a === void 0 ? void 0 : _a.id) {
            updateSpace({
                id: space.id,
                input: {
                    imageId: uploadedImage[0].id,
                },
            });
        }
    }, [createImages, updateSpace, space]);
    const { onSelectFile, children: cropModal } = useCropImageModal({
        onSuccess: ({ croppedImage }) => uploadFile([croppedImage]),
        options: {
            shape: 'rect',
        },
    });
    return canUpdateSpace && !readOnly ? (_jsxs(_Fragment, { children: [_jsx(PopoverImagePicker, { tabs: ['emoji', 'upload', 'link'], sizeConfig: {
                    recommendedWidth: 512,
                    recommendedHeight: 512,
                }, onImageChange: files => onSelectFile(files === null || files === void 0 ? void 0 : files[0]), onEmojiChange: async (emoji) => {
                    const uploadedEmoji = await createEmojis([{ text: emoji === null || emoji === void 0 ? void 0 : emoji.id }]);
                    updateSpace({
                        id: space.id,
                        input: {
                            imageId: uploadedEmoji[0].id || emoji.id,
                        },
                    });
                }, children: _jsx(SpaceImageReadOnly, { size: size, space: space }, void 0) }, void 0), cropModal] }, void 0)) : (_jsx(SpaceImageReadOnly, { size: size, space: space }, void 0));
};
//# sourceMappingURL=SpaceImage.js.map